import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import { PageTemplate } from "../common/PageTemplate";
import DataGrid from '../../../../OurModules/DataGrid/src/index.js';
import * as FileSaver from 'file-saver';
/**
 * Container component for the Documents page.
 * 
 */
class Dcuments extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showLoader: true, documnentsList: [], shouldLoadData: true };
        this.getDocument = this.getDocument.bind(this);
        this.saveDocument = this.saveDocument.bind(this);
    }

    componentDidMount() {
        //this.props.getDocsList();
        logUI("MBHWeb.UI.DocumentList.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);

    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;
        if (this.props.documnentsList !== prevProps.documnentsList) {
            if (this.props.documnentsList) {
                let docs = this.props.documnentsList;
                this.setState({ documnentsList: docs && docs.length > 0 ? docs : [], showLoader: false });
            }
        }
        if ((swhp || hpIdentity) && this.state.shouldLoadData && !isFetching) {
            this.props.getDocsList();
            this.setState({ shouldLoadData: false });
        }

        if (this.props.documentDetails !== prevProps.documentDetails || this.props.error !== prevProps.error) {
            this.setState({ showEobLoader: false });
            this.saveDocument();
        }
    }

    getDocument(e) {
        console.log(e);
        if (e.ExternalUrl != null && e.ExternalUrl != "") {
            window.open(e.ExternalUrl);
        }
        else {
            console.log(e.FileId, e.DocumentTitle);
            this.props.getDocumentDetails(e.FileId, e.DocumentTitle);
        }
    }

    saveDocument() {
        if (this.props.error || !this.props.documentDetails || this.props.documentDetails.status === 204) {
            this.setState({ showEobErrorMessage: true });
            return;
        }

        FileSaver.saveAs(this.props.documentDetails, this.props.docName);
    }

    render() {
        var columnMetadata = [
            {
                type: "string",
                title: "Document Title",
                value: "DocumentTitle",
                allowSorting: true
            },
            {
                type: "string",
                title: "Document Type",
                value: "DocumentType",
                allowSorting: true
            },
        ]
        var gridMetadata = {
            title: "",
            enableFilters: false,
            searchFields: ["DocumentTitle", "DocumentType"],
            searchPlaceholder: "Search by Document Name or Type",
            enableSearch: true,
            sortingEnabled: true,
            pagination: true, //not implemented
            rowsPerPage: 10, //not implemented
            rowClick: this.getDocument,
            columns: columnMetadata
        }
        return (
            <PageTemplate objectName='documents-and-resources' pageTitle='Documents and Resources' >
               
                        <DataGrid id="documents-data-grid" dataSource={this.state.documnentsList} gridOptions={gridMetadata} showLoader={this.state.showLoader}></DataGrid>
                    
            </PageTemplate>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isFetching: state.healthPlanServices.isFetching,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        documnentsList: state.healthPlanServices.docs,
        documentDetails: state.healthPlanServices.docDetails,
        docName: state.healthPlanServices.docName,
        error: state.healthPlanServices.error,

        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDocsList: () => dispatch({ type: types.HP_GET_DOCUMENTS_LIST_START }),
        getDocumentDetails: (fileId, fileName) => dispatch({ type: types.HP_GET_DOCUMENT_DETAIL_START, fileId: fileId, fileName: fileName })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dcuments));
